import { render, staticRenderFns } from "./public.layout.vue?vue&type=template&id=2d4c530e&scoped=true&lang=pug"
import script from "./public.layout.vue?vue&type=script&lang=ts"
export * from "./public.layout.vue?vue&type=script&lang=ts"
import style0 from "./public.layout.vue?vue&type=style&index=0&id=2d4c530e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c530e",
  null
  
)

export default component.exports